import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinvimannagar() {



  const cardData =
  {
    keyword: 'Corporate Cab Service in Viman Nagar',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Service in Viman Nagar',
    headingDescription: ' Pune Corporate Cars India Private Limited offers premium Corporate Cab Service in Viman Nagar, delivering reliable, comfortable, and executive-level travel solutions for businesses, IT companies, and corporate professionals. Our fleet of luxury sedans, SUVs, and high-end cars provides smooth transportation for daily office commutes, airport transfers, client pickups, meetings, and VIP travel. With professionally trained chauffeurs, punctual service, and flexible rental options, we ensure a seamless and stress-free travel experience. Whether your business needs dedicated cabs, chauffeur-driven rentals, or on-demand corporate travel, Pune Corporate Cars India Private Limited delivers safe, efficient, and top-quality mobility services perfectly suited for Viman Nagar’s corporate environment.',

    top: 'Top Places to Visit in Pune with Pune Corporate Car',

    "topPlaces": [
    {
      "title": "Hinjewadi Rajiv Gandhi Infotech Park",
      "description": "Hinjewadi Phase 1, 2 and 3 together form Pune’s largest corporate ecosystem, home to global IT companies, MNCs, tech parks, and business hubs. With campuses of Infosys, Wipro, Cognizant, TCS and more, it is Pune’s primary employment corridor. The area has wide roads, 24×7 transport demand, cafes, business hotels, and constant corporate mobility needs — making it one of the busiest routes served by Pune Corporate Cars."
    },
    {
      "title": "Magarpatta Cybercity",
      "description": "Magarpatta Cybercity is a self-sustained corporate township combining IT parks, residential spaces, restaurants, and premium office buildings. Known for its clean, green, and secure environment, it hosts major IT giants like Accenture, Infosys, Capgemini and Barclays. Corporate travel requirements, employee drop services, and daily office commutes make it a major business hub in Pune."
    },
    {
      "title": "Kharadi EON IT Park",
      "description": "EON IT Park is Pune’s fastest-growing commercial destination, filled with high-rise IT towers, premium offices, and multinational companies. Its four major clusters (A, B, C, D) attract thousands of daily employees. With tech companies, co-working spaces, and international business centers, Kharadi is a top route for corporate pick-drop and airport transfers."
    },
    {
      "title": "Viman Nagar Business District",
      "description": "Viman Nagar is a premium corporate and lifestyle hub near Pune Airport, known for its modern business centers, coworking spaces, hotels, and commercial complexes. Major malls, restaurants, and connectivity to Kharadi, Koregaon Park, and Yerwada make it a preferred zone for corporate travel, meetings, and executive cab services."
    },
    {
      "title": "Baner–Balewadi Corporate Hub",
      "description": "Baner and Balewadi have transformed into Pune’s new-age commercial cluster with IT companies, startups, co-working hubs, and premium business towers. It offers a cosmopolitan corporate environment with cafés, boardrooms, and business hotels. The area’s proximity to Hinjewadi makes corporate cab requirements extremely high for daily office mobility."
    },
    {
      "title": "Chakan MIDC Industrial Area",
      "description": "Chakan MIDC is one of India’s biggest industrial and automobile manufacturing clusters, housing companies like Volkswagen, Mercedes-Benz, Bajaj, LG, and Mahindra. With 24×7 transport operations, staff shifts, and inter-plant travel, it is a prime location served by corporate cab services, staff shuttle operations, and industrial commute solutions."
    },
    {
      "title": "Talegaon MIDC",
      "description": "Talegaon MIDC is known for its global manufacturing units, auto plants, and logistics hubs. It hosts companies such as General Motors, L&T, JCB, and POSCO. The area witnesses heavy employee movement and frequent business visits from executives — making structured corporate mobility critical for smooth travel between Pune city and the MIDC."
    },
    {
      "title": "Yerwada Business Corridor",
      "description": "Yerwada is a major commercial zone with corporate towers, business parks, and high-end office spaces like ICC Tech Park and Commerzone. It is a preferred location for corporate meetings, finance companies, and consulting firms. Its close connectivity to the airport and EON makes it a frequent route for corporate cabs and executive travel."
    },
    {
      "title": "Koregaon Park Business & Lifestyle District",
      "description": "Koregaon Park blends premium business centers with high-end lifestyle spaces, cafés, and boutique offices. It attracts startups, creative agencies, international firms, and co-working workspaces. The area is ideal for board meetings, client visits, and VIP travel — heavily relying on professional chauffeur-driven cabs."
    },
    {
      "title": "Pimpri-Chinchwad Industrial Belt",
      "description": "PCMC is one of Pune’s strongest industrial belts, filled with auto, engineering, and manufacturing companies. Areas like Pimpri, Chinchwad, Bhosari, and Nigdi host major factories and R&D centers. With shift-based employee travel and factory visits, corporate cab services remain essential for day-to-day operations."
    }
  ],



"services": [
  {
    "name": "Viman Nagar Business Cab",
    "description": "Viman Nagar Business Cab offers premium and punctual travel solutions for executives, managers, and professionals working in the Viman Nagar commercial zone. With clean, AC-equipped sedans and SUVs, along with trained corporate chauffeurs, we ensure smooth travel for meetings, office visits, and client interactions. Viman Nagar Business Cab delivers reliability, comfort, and professional service for daily corporate mobility."
  },
  {
    "name": "Viman Nagar Corporate Taxi",
    "description": "Viman Nagar Corporate Taxi provides high-quality and well-managed taxi services tailored for corporate clients. Ideal for office commute, business visits, airport transfers, and executive travel, our vehicles are regularly maintained and driven by disciplined chauffeurs. With flexible booking options and timely service, Viman Nagar Corporate Taxi ensures a smooth and professional travel experience for companies operating in the area."
  },
  {
    "name": "Airport Road Office Cab",
    "description": "Airport Road Office Cab offers dependable and quick office commute solutions for employees working near Viman Nagar and the Airport Road corporate belt. Our service includes scheduled pick-up and drop routes, verified chauffeurs, and well-maintained vehicles. Designed for IT firms, business centers, and corporate offices, Airport Road Office Cab ensures timely and comfortable daily travel."
  },
  {
    "name": "Viman Nagar Employee Shuttle",
    "description": "Viman Nagar Employee Shuttle provides efficient group transportation for companies with large teams. With AC shuttles, minibuses, and tempo travellers, we manage shift-based operations, fixed routes, and coordinated pickups. Perfect for IT parks, BPOs, and corporate hubs, Viman Nagar Employee Shuttle ensures secure, timely, and hassle-free employee mobility every day."
  },
  {
    "name": "Corporate Fleet Service Viman Nagar",
    "description": "Corporate Fleet Service Viman Nagar delivers comprehensive fleet solutions with sedans, SUVs, vans, and tempo travellers dedicated to your organization. We manage drivers, maintenance, replacements, and route coordination. Companies benefit from centralized billing, scalable fleet options, and professional support. Corporate Fleet Service Viman Nagar is ideal for businesses requiring long-term, reliable mobility."
  },
  {
    "name": "Staff Transportation Viman Nagar",
    "description": "Staff Transportation Viman Nagar offers safe, punctual, and organized travel solutions for employees across all office locations. We operate GPS-enabled vehicles with trained chauffeurs to ensure stress-free commuting, including early-morning and late-night shifts. Staff Transportation Viman Nagar helps companies improve employee satisfaction, attendance, and daily work efficiency."
  },
  {
    "name": "Business Travel Cabs Viman Nagar",
    "description": "Business Travel Cabs Viman Nagar provides comfortable and reliable travel for meetings, corporate events, airport runs, and inter-office visits. Our fleet includes premium sedans and SUVs driven by courteous professionals. With flexible booking options and clean interiors, Business Travel Cabs Viman Nagar ensures smooth and productive corporate mobility for business travellers."
  },
  {
    "name": "IT Park Cab Viman Nagar",
    "description": "IT Park Cab Viman Nagar offers dedicated transportation services for employees working in nearby tech parks and corporate hubs. Our service includes structured routes, shift-based scheduling, and well-maintained AC vehicles. Ideal for tech companies and IT professionals, IT Park Cab Viman Nagar ensures consistent, safe, and comfortable office travel."
  },
  {
    "name": "Best Corporate Cabs Viman Nagar",
    "description": "Best Corporate Cabs Viman Nagar delivers high-standard travel services with clean, comfortable vehicles and experienced chauffeurs. We handle daily office commute, executive meetings, airport transfers, and short business trips. Known for punctuality and professional service, Best Corporate Cabs Viman Nagar is trusted by companies across the corporate district."
  },
  {
    "name": "Viman Nagar Chauffeur Cars",
    "description": "Viman Nagar Chauffeur Cars provides luxury chauffeur-driven sedans and SUVs for executives, VIP clients, and corporate leaders. Chauffeurs are trained in etiquette, confidentiality, and safe driving. Cars feature plush seating, AC, and perfectly maintained interiors. Viman Nagar Chauffeur Cars ensures a premium and stress-free travel experience for high-profile business travellers."
  },
  {
    "name": "Viman Nagar Monthly Cab Hire",
    "description": "Viman Nagar Monthly Cab Hire offers long-term cab services with dedicated vehicles and drivers assigned to your organization. Monthly plans include predictable billing, sanitized cars, and priority replacements. Ideal for daily office commute, executive travel, and field visits. Viman Nagar Monthly Cab Hire ensures consistent and professional transportation month after month."
  },
  {
    "name": "Corporate SUV Rental Viman Nagar",
    "description": "Corporate SUV Rental Viman Nagar provides spacious and comfortable SUVs such as Ertiga, Innova, and Crysta for corporate travel. SUVs are ideal for group movement, long-distance travel, and executive journeys. Chauffeurs ensure smooth, safe, and timely service. Corporate SUV Rental Viman Nagar enhances comfort and professionalism for business travel."
  },
  {
    "name": "Corporate Sedan Cabs Viman Nagar",
    "description": "Corporate Sedan Cabs Viman Nagar offers elegant sedans including Dzire, Etios, Honda City, and Verna for executive travel. Perfect for meetings, airport transfers, and business visits, these cars ensure a smooth and professional ride. Our trained chauffeurs maintain punctuality and corporate etiquette. Corporate Sedan Cabs Viman Nagar provides a premium travel experience for corporate clients."
  },
  {
    "name": "Outstation Cabs Viman Nagar",
    "description": "Outstation Cabs Viman Nagar offers reliable intercity travel for business trips, factory visits, conferences, and long-distance corporate travel. Vehicles include sedans and SUVs with comfortable interiors and safe suspension. Chauffeurs are experienced in highway routes and maintain punctuality. Outstation Cabs Viman Nagar ensures safe, smooth, and professional travel for all corporate outstation needs."
  },
  {
    "name": "Office Pick Drop Viman Nagar",
    "description": "Office Pick Drop Viman Nagar provides structured pickup and drop solutions for employees working in the area. We offer fixed schedules, verified drivers, and GPS-enabled vehicles for maximum safety. Ideal for companies with shift-based or regular office hour requirements. Office Pick Drop Viman Nagar ensures punctual, comfortable, and organized daily office commuting."
  }
],
"tableData": [
  ["Viman Nagar Business Cab", "Viman Nagar Corporate Taxi"],
  ["Airport Road Office Cab", "Viman Nagar Employee Shuttle"],
  ["Corporate Fleet Service Viman Nagar", "Staff Transportation Viman Nagar"],
  ["Business Travel Cabs Viman Nagar", "IT Park Cab Viman Nagar"],
  ["Best Corporate Cabs Viman Nagar", "Viman Nagar Chauffeur Cars"],
  ["Viman Nagar Monthly Cab Hire", "Corporate SUV Rental Viman Nagar"],
  ["Corporate Sedan Cabs Viman Nagar", "Outstation Cabs Viman Nagar"],
  ["Office Pick Drop Viman Nagar", ""]
],


  






"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Service in Viman Nagar",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides premium and reliable corporate cab services in Viman Nagar, ensuring smooth and professional travel for employees and executives."
  },
  {
    "WhyChooseheading": "Ideal for Corporate & Commercial Zones",
    "WhyChoosedescription": "Our services are perfectly suited for offices, co-working spaces, and commercial hubs in Viman Nagar, offering punctual and hassle-free daily commuting."
  },
  {
    "WhyChooseheading": "Comfortable & Well-Maintained Vehicles",
    "WhyChoosedescription": "All our cabs are regularly serviced, sanitized, and equipped to offer a safe and comfortable ride for corporate travelers."
  },
  {
    "WhyChooseheading": "Transparent Corporate Pricing",
    "WhyChoosedescription": "We offer clear and competitive pricing with no hidden charges, making it ideal for startups, SMEs, and large corporations in Viman Nagar."
  },
  {
    "WhyChooseheading": "Flexible Travel Plans",
    "WhyChoosedescription": "Choose from daily, weekly, and monthly packages designed to match your corporate schedules and employee travel requirements."
  },
  {
    "WhyChooseheading": "Professional & Courteous Drivers",
    "WhyChoosedescription": "Our experienced chauffeurs ensure timely pickups, safe driving practices, and a smooth travel experience for all corporate passengers."
  },
  {
    "WhyChooseheading": "24/7 Dedicated Customer Support",
    "WhyChoosedescription": "Our support team is available round-the-clock to handle bookings, schedule changes, and urgent travel requests for Viman Nagar clients."
  },
  {
    "WhyChooseheading": "Easy & Quick Booking Process",
    "WhyChoosedescription": "Book your corporate cab for Viman Nagar through our simple online system or by phone, with fast confirmations and dependable service."
  }
]





















  }

const faqData = [
  {
    question: 'Does Pune Corporate Cars India Private Limited offer corporate cab services in Viman Nagar?',
    answer: 'Yes, Pune Corporate Cars India Private Limited provides reliable and premium corporate cab services in Viman Nagar for office commute, business meetings, and corporate events.',
  },
  {
    question: 'How can I book a corporate cab in Viman Nagar with Pune Corporate Cars India Private Limited?',
    answer: 'You can book easily through our website, mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What types of vehicles are available for corporate cab services in Viman Nagar?',
    answer: 'We offer hatchbacks, sedans, SUVs, and luxury cars to match various corporate travel needs in Viman Nagar.',
  },
  {
    question: 'Are the drivers trained for corporate transportation in Viman Nagar?',
    answer: 'Yes, all our drivers are professionally trained, punctual, and experienced with corporate travel expectations.',
  },
  {
    question: 'Do you offer daily, weekly, and monthly corporate cab packages in Viman Nagar?',
    answer: 'Absolutely. We offer flexible corporate cab packages including daily, weekly, and monthly plans tailored for companies in Viman Nagar.',
  },
  {
    question: 'Is the corporate cab service available 24×7 in Viman Nagar?',
    answer: 'Yes, Pune Corporate Cars India Private Limited provides round-the-clock availability to support your business travel needs.',
  },
  {
    question: 'What safety protocols are followed for corporate cabs in Viman Nagar?',
    answer: 'All vehicles are sanitized regularly and drivers follow strict safety and hygiene measures for every ride.',
  },
  {
    question: 'What payment options are accepted for corporate cab services in Viman Nagar?',
    answer: 'We accept UPI, credit/debit cards, net banking, digital wallets, and corporate invoicing.',
  },
  {
    question: 'Is customer support available during the service period for Viman Nagar clients?',
    answer: 'Yes, our dedicated 24×7 customer support team is always available to assist during your service period.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohit Kulkarni',
    feedback: 'Top-notch corporate cab service in Viman Nagar. Clean cars, professional drivers, and always on time. Highly recommended.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Sana Apte',
    feedback: 'Our company relies on Pune Corporate Cars India Private Limited for daily commute in Viman Nagar. Excellent service and great coordination.',
    rating: 5,
  },
];










































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Service in Viman Nagar",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cabs-viman-nagar.jpg", // replace with actual image URL
  "description": "Reliable corporate cab services in Viman Nagar, Pune, offering employee shuttle, office pickup and drop, IT park transport, and business travel cabs. Pune Corporate Cars India Private Limited provides chauffeur-driven sedans, SUVs, and outstation cabs for comfortable corporate commuting.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",  // update if needed
    "ratingCount": "4500", // update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1500", // starting price, adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-service-viman-nagar"
  }
};







  return (
    <div>
<Helmet>
  <title>Corporate Cab Service in Viman Nagar | Employee & Office Cabs | Pune Corporate Cars India Private Limited</title>

  <meta
    name="description"
    content="Reliable corporate cab services in Viman Nagar, Pune, offering employee shuttle, office pickup and drop, IT park transport, and business travel cabs. Pune Corporate Cars India Private Limited provides chauffeur-driven sedans, SUVs, and outstation cabs for comfortable corporate commuting."
  />

  <meta
    name="keywords"
    content="Viman Nagar Business Cab, Viman Nagar Corporate Taxi, Airport Road Office Cab, Viman Nagar Employee Shuttle, Corporate Fleet Service Viman Nagar, Staff Transportation Viman Nagar, Business Travel Cabs Viman Nagar, IT Park Cab Viman Nagar, Best Corporate Cabs Viman Nagar, Viman Nagar Chauffeur Cars, Viman Nagar Monthly Cab Hire, Corporate SUV Rental Viman Nagar, Corporate Sedan Cabs Viman Nagar, Outstation Cabs Viman Nagar, Office Pick Drop Viman Nagar"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/8.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinvimannagar;